<template>
<ty-modal :visible="true" :before-close="handleClose" width="60%">
	<Create class="mt-3"  @created="created"/>
</ty-modal>
</template>

<script>
import Create from '../components/ShopCreateDiscountForm.vue'
export default {
  components: {
    Create,

  },
  methods: {
		handleClose() {
			this.$router.back();
    },
    created () {
      this.$router.replace({name: 'shop-customers'})
    },
  },
}
</script>